<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;" id="rccx">
      <b>操作人：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.para2"
                placeholder="操作人"/>
      <b>操作人IP：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.para1"
                placeholder="操作人IP"/>
      <el-button type="primary" @click="getList" size="medium" round><i class="el-icon-search"></i>查询</el-button>
      <el-button type="warning" @click="cleardata" size="medium" round><i class="el-icon-refresh"></i>重置</el-button>
    </div>
    <el-table v-loading="loading"
              :data="tableData"
              style="width: 100%">
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作简介" prop="title" align="center"></el-table-column>
      <el-table-column label="操作路径" prop="operUrl" align="center"></el-table-column>
      <el-table-column label="操作人" prop="operName" align="center"></el-table-column>
      <el-table-column label="操作ip地址" prop="operIp" align="center">
      </el-table-column>
      <el-table-column label="操作时间" prop="operTime" align="center"
      ></el-table-column>
      <el-table-column label="耗时(ms)" prop="costTime" align="center">
      </el-table-column>

      <el-table-column
          align="center" label="操作" width="100">

        <template slot-scope="scope">
          <el-button
              size="mini"
              @click="querydata(scope.row)">
            <i class="el-icon-setting"></i>
            查看参数
          </el-button>

        </template>
      </el-table-column>
    </el-table>

    <template>
      <div>

        <pagination
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>

    <el-dialog title="日志参数" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="form" id="scfrom" label-width="130px">

        <el-form-item label="请求入参">
          <el-input type="textarea"  v-model="form.operParam" :rows="3"
                   ></el-input>
        </el-form-item>
        <el-form-item label="请求出参">
          <el-input type="textarea" v-model="form.jsonResult" :rows="3"
                    ></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>




  </div>

</template>
<script>
import Pagination from "../../component/Pagination/index.vue";

export default {
  components: {Pagination},
  data() {
    return {
      file1src: '',
      total: 0,
      pid: '',
      scinfo: {
        id: '',
        scstate: '',
        opinion: ''
      },
      projecttypes: [],
      pwfileList: [],
      form: {
        operParam: '',
        jsonResult: ''
      },
      dialogpdfVisibledel: false,

      createvueVisible: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        para1: undefined,
        para2: undefined
      },
      selectTable: {
        title: '新增权限',
        id: 0,
        role: '',
        rolename: '',
        defalutCheckArr: [],
        rptid: 0
      },
      defaultProps: {
        children: "children",
        label: "pname"
      },
      // 菜单列表
      dialogFormVisible: false,
      dialogFormData: [],
      tableData: [],
      DicData: [],
      tablelistData: [],
      search: '',
      loading: false
    }
  },
  mounted() {
    this.getList();
    // this.getDic('projecttype')
  },
  methods: {
    getDic(val) {
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: val},
        success: (data) => {
          this.projecttypes = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },

    formatDate(row) {
      const timestamp = row.completiontime;
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
      return formattedDate;
    },

    cleardata() {
      this.queryParams = this.$options.data().queryParams
      this.getList()
    },

    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/system/operatloglist",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },

    querydata( row) {
      this.form = this.$options.data().form
      this.form.jsonResult = row.jsonResult
      this.form.operParam = row.operParam
      this.dialogFormVisible=true
    },


  },
}
</script>
<style>
#rccx .el-date-editor.el-input {
  width: 100px !important;
}

selectupwidth el-select {
  width: 120px;
}

/*#roleListpage .el-pager li.active {
  color: white;
}*/

#pdfdialog .el-dialog--small {
  top: 3% !important;
  width: 86% !important;
  height: 93% !important;
}

#scfrom .el-input.is-disabled .el-input__inner {
  background-color: white;
  border-color: white;
  color: #4e4e59;
  padding-bottom: 4px;
}

#scfrom .el-textarea.is-disabled .el-textarea__inner {
  background-color: white;
  border-color: #C0C4CC;
  color: #4e4e59;
  padding-bottom: 4px;
}
</style>